import type { ReactNode } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { AppSessionProvider } from '@/state/session/provider'
import { HabitpackThemeProvider } from '@/app/providers/habitpack-theme-provider'
import { queryClient } from '@/lib/query/query-client'
import { ErrorBoundary } from '@/components/feedback/error-boundary'

export function AppProviders({ children }: { children: ReactNode }): React.JSX.Element {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AppSessionProvider>
            <HabitpackThemeProvider>
              {children}
            </HabitpackThemeProvider>
          </AppSessionProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  )
}
